/// <reference path="../../../../typings/index.d.ts" />

module Meevo.Plugins.SecurityRoles {
  angular.module("meevo.plugins.securityRoles", []);
}